import serviceBase from '../../../Services/serviceBase'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'

class ResidentialPlanDialogActions {
  getResidentialPlanDetail = async (id, iarMember) => {
    const scapeIarMember = _.deburr(iarMember)
    if (id !== undefined) {
      let url = `${window._env_.COMMUNITY_API_URL}/residential-plan/${id}`

      return serviceBase
        .get(url, null, {
          crossDomain: true,
          'Content-Type': 'application/json',
          Authorization: ``,
          sourcesystem: '1',
          fullusername: scapeIarMember
        })
        .then(
          (response) => {
            return response.data
          },
          (err) => {}
        )
    }
  }

  approveResidentialPlan = async (ids, iarMember) => {
    const scapeIarMember = _.deburr(iarMember)
    let url = `${window._env_.COMMUNITY_API_URL}/residential-plan/approve`
    return serviceBase
      .post(
        url,
        { toApprove: ids },
        {
          crossDomain: true,
          'Content-Type': 'application/json',
          Authorization: ``,
          sourcesystem: '1',
          fullusername: scapeIarMember
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            return true
          } else {
            return false
          }
        },
        (err) => {}
      )
  }

  deleteResidentialPlan = async (id, iarMember, setResidentialPlansEntity, residentialplans) => {
    const scapeIarMember = _.deburr(iarMember)
    let url = `${window._env_.COMMUNITY_API_URL}/residential-plan/delete?id=${id}`
    return serviceBase
      .post(
        url,
        { id: id },
        {
          crossDomain: true,
          'Content-Type': 'application/json',
          Authorization: ``,
          sourcesystem: '1',
          fullusername: scapeIarMember
        }
      )
      .then(
        (response) => {
          if (response.status === 200) {
            const newResidentialPlans = residentialplans.filter((e) => e._id !== id)
            setResidentialPlansEntity((prevState) => ({
              ...prevState,
              residentialPlans: newResidentialPlans
            }))
            return true
          } else {
            return false
          }
        },
        (err) => {}
      )
  }
}

const residentialPlanDialogActions = new ResidentialPlanDialogActions()

export default residentialPlanDialogActions
